import React from 'react';

const cx = (...a) => a.filter(Boolean).join(' ');

const scaleMap = { xs: 1, sm: 2, md: 4, lg: 6, xl: 8 };

export default function Spacer({
    size = 'md',
    direction = 'vertical',
    inline = false,
    className = '',
    style,
}) {
    const n = typeof size === 'number' ? size : scaleMap[size] ?? scaleMap.md;
    const dimClass = direction === 'vertical' ? `h-${n} w-px-0` : `w-${n} h-px-0`;
    const majorClass = direction === 'vertical' ? `h-${n}` : `w-${n}`;

    return (
        <span
            aria-hidden="true"
            role="presentation"
            className={cx(
                inline ? 'inline-block' : 'block',
                direction === 'vertical' ? 'w-full' : 'h-full',
                majorClass,
                className
            )}
            style={style}
        />
    );
}